import { TabLink } from "../TabLink";
import { TABS_LABELS, TABS_URLS } from "./helpers";
import { useAppStore } from "@/common/store/appStore";
import { MenuItem } from "@/components/burger-menu/MenuItem";
import { useDeviceType } from "@/common/hooks";
import { deviceTypeEnum } from "@/common/utils/device";
import { useFooterMenuItems } from "./hooks/useFooterMenuItems";
import "./ApplicationFooter.scss";
import { LegalLinks } from "../LegalLinks";
import { useUserStore } from "@/common/store";

interface IApplicationFooterProps {
  currentUserName: string | null;
  onSendMetricAndCloseMenu: (tabName: TABS_URLS, label: TABS_LABELS, targetUrl: string) => void;
  isTabActive: (tab: string) => string | boolean | null;
  onProfileClick: () => void;
}

export const ApplicationFooter: React.FC<IApplicationFooterProps> = ({
  currentUserName,
  onSendMetricAndCloseMenu,
  isTabActive,
  onProfileClick,
}) => {
  const isProfileMenuOpen = useAppStore((state) => state.isProfileMenuOpen);
  const isDesktop = useDeviceType() === deviceTypeEnum.DESKTOP;
  const isVerified = !!useUserStore((state) => state.currentUser?.verified);

  const menuItems = useFooterMenuItems({
    currentUserName,
    isTabActive,
    onSendMetricAndCloseMenu,
    onProfileClick,
    isProfileMenuOpen,
    isVerified,
  });

  const FooterItems = isDesktop ? MenuItem : TabLink;

  return (
    <div className="ApplicationFooter">
      <div className="ApplicationFooter-Container">
        {menuItems.map(item => (
          <FooterItems key={item.title} {...item} />
        ))}
      </div>
      <LegalLinks />
    </div>
  );
};
